import SSRemixer from "./remixer8773.js";
import Remix from "./remix.js";
export function initiateRemixer(workletPath, wasmPath, video, duetVideo, remix, jam) {
  let remixSong = new Remix(remix, jam);
  const Rec = new SSRemixer(workletPath, wasmPath, video, duetVideo, remixSong);
  return Rec;
}
